import { z } from "zod";

const focusModeOptInDataSchema = z.object({
  focusModeSessionId: z.string(),
  startedAt: z.string(),
  shiftEndAt: z.string(),
  bonusPoints: z.number(),
});

export const focusModeOptInResponseSchema = z.object({
  data: focusModeOptInDataSchema,
});

export type FocusModeOptInResponse = z.infer<typeof focusModeOptInResponseSchema>;

export const focusModeViolationRequestSchema = z.object({
  focusModeSessionId: z.string(),
  violationType: z.enum(["app_background", "route_change"]),
  occurredAt: z.string(),
  durationMs: z.number(),
});

export type FocusModeViolationRequest = z.infer<typeof focusModeViolationRequestSchema>;

const focusModeStatusDataSchema = z.object({
  isOptedIn: z.boolean(),
  focusModeSessionId: z.string(),
  startedAt: z.string(),
  hasViolations: z.boolean(),
  violationCount: z.number(),
  bonusPoints: z.number(),
  status: z.enum(["active", "completed_success", "completed_failed"]),
});

export const focusModeStatusResponseSchema = z.object({
  data: focusModeStatusDataSchema,
});

export type FocusModeStatusResponse = z.infer<typeof focusModeStatusResponseSchema>;
